// 左カラムのメニュー定義（表示順はこの配列の順序に従う）
const MENU_ITEMS = [
  { id: "projectTotalShots", name: "チェックポイント" },
  { id: "projectSchedule", name: "全体スケジュール" },
  { id: "projectShotTags", name: "タグ" },
  { id: "projectCodeName", name: "コードネーム" },
  { id: "projectBanner", name: "バナー" },
  { id: "projectOverview", name: "概要" },
  { id: "projectFinalWork", name: "目的物" },
  { id: "projectEndClient", name: "エンドクライアント" },
  { id: "projectAcr", name: "楽曲照合結果" },
  { id: "projectTaskBoard", name: "タスクボード共有" },
  { id: "projectGitHub", name: "GitHub" },
];

const leftColumnList = ({ setSelectedItem, setShowRightColumn, canManageTaskBoard }) =>
  MENU_ITEMS
    // タスクボード共有は責任者プロデューサー・管理者のみに表示する。
    .filter((item) => item.id !== "projectTaskBoard" || canManageTaskBoard)
    .map((item) => ({
      ...item,
      onClick: () => {
        setSelectedItem(item.id);
        setShowRightColumn(true);
      },
    }));

export default leftColumnList;
